<template>
  <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="showMini"
      :permanent="isLarge"
      app
      color="primary darken-1"
      class="nav-drawer"
      v-show="getUser != null"
    >
      <!-- Header Section -->
      <div class="drawer-header">
        <v-list-item class="header-content px-2" v-if="!open || !isLarge">
          <v-list-item-avatar class="logo-container">
            <v-img
              :src="logo"
              height="40"
              aspect-ratio="1"
              class="logo-image"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              class="institution-name"
            >
              {{ navDetails.shortName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Mini Header -->
        <!-- <v-list-item class="mini-header px-2">
          <v-list-item-icon>
            <v-icon color="white" size="32">mdi-school</v-icon>
          </v-list-item-icon>
        </v-list-item> -->
      </div>

    <v-list class="nav-list">
      <v-list-item class="nav-item" link to="/">
        <v-list-item-icon>
          <v-icon :size="iconSize">mdi-speedometer</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title >Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!--      Management-->
      <template>
          <v-subheader v-if="!open && isLargeAndUp" class="mt-4 section-header">
            LINKS
          </v-subheader>
          <v-list-item
        class="nav-item"
          v-for="item in filteredLinks"
          :key="item.title"
          link
          :to="'/'+item.url"
          v-show="((!item.cleared || (item.cleared && isCleared)) && (!item.mustBePermanent || (item.mustBePermanent && isPermanent)))"
        >
        <v-list-item-icon>
              <v-badge
              v-if="getUser?.notificationCount && item.url === 'notification'"
              :content="getUser?.notificationCount"
              :value="getUser?.notificationCount"
              color="error"
              overlap
            >
              <v-icon :size="iconSize">{{ item.icon }}</v-icon>
            </v-badge>
            <v-icon v-else :size="iconSize">{{ item.icon }}</v-icon>
            </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.title === 'Accommodation' ? 'Hostel' : item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>


      <template>
          <v-subheader v-if="!open && isLargeAndUp" class="mt-4 section-header">
            SETTINGS
          </v-subheader>

          <v-list-item
          class="nav-item"
          v-for="item in settings"
          :key="item.title"
          link
          :to="'/'+item.url"
          v-show="((!item.cleared || (item.cleared && isCleared)) && (!item.mustBePermanent || (item.mustBePermanent && isPermanent)))"
        >
          <v-list-item-icon>
            <v-icon :size="iconSize">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <div class="logout-section">
          <v-list-item
            v-if="getSuper"
            @click="exitSuper"
            class="nav-item exit-super"
          >
            <v-list-item-icon>
              <v-icon color="amber" :size="iconSize">mdi-arrow-left</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Exit Current</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="logUserOut"
            class="nav-item logout"
          >
            <v-list-item-icon>
              <v-icon :size="iconSize">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
                 v-on:close-message="messageShow = !messageShow"></message-box>
  </v-navigation-drawer>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import Api from '@/main/api';
import Links from "@/shared/constants/Links";
import Defaults from "@/shared/Defaults";
import ErrorResolver from "@/shared/ErrorResolver";
import NavigationLinks from "@/shared/NavigationLinks";
import LoadingDialog from "@ui/components/LoadingDialog.vue";
import MessageBox from "@ui/components/MessageBox.vue";
import StudentStatus from "@/shared/StudentStatus";

export default {
  name: "NavigationDrawerStudent",
  components: {MessageBox, LoadingDialog},
  props: {
    open: Boolean,
  },

  data: () => ({
    drawer: false,
    links: NavigationLinks.StudentLinks.management,
    settings: NavigationLinks.StudentLinks.settings,
    iconSize: 18,
    logo: Defaults.api + Links.global.logo,
    navDetails: {},
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
  }),

  methods: {
    logUserOut() {
      this.logout()
      // this.setCurrentUser({user: null})
      window.location.href = '/login'
    },

    fetchGlobal() {
      Api.global.fetch().then((res) => {
        this.navDetails = res.data
        this.logo = Defaults.api + Links.global.logo
      }).catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    exitSuper() {
      this.loading = true
      Api.auth.revertSwitchUser({
        user: this.getUser.userId
      })
        .then(res => {
          window.close() // close tab
          // store token
          // LoginUtil.setAccessToken(res.data.jwt)
          // LoginUtil.setRefreshToken(res.data.refreshToken);
          // // change location
          // window.location.href = "/main"
        }).catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    ...mapActions(['logout']),
    ...mapMutations(['setCurrentUser'])
  },

  computed: {
    ...mapGetters(['getProgrammeTypes', 'getCurrentProgrammeType', 'getUser', 'getSuper']),
    isCleared: function () {
      return this.getUser != null && this.getUser.cleared;
    },

    isPermanent: function () {
      console.log("On isPermanent")
      return this.getUser != null &&
        (StudentStatus[this.getUser.studentStatus].value > StudentStatus[this.getUser.yearOfAdmission?.programmeType?.studentDashboardAccessStatus ?? StudentStatus.CLEARED.text].value || [StudentStatus.STUDENT.text, StudentStatus.GRADUATED.text, StudentStatus.PROGRAMME_CHANGE.text].includes(this.getUser.studentStatus)) &&
        this.getUser.temporal === undefined;
    },

    isLargeAndUp: function () {
      return this.$vuetify.breakpoint.lgAndUp
    },

    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    },

    isMedium: function () {
      return this.$vuetify.breakpoint.mdOnly
    },

    isMediumAndDown: function () {
      return this.$vuetify.breakpoint.mdAndDown
    },


    isMediumAndUp: function () {
      return this.$vuetify.breakpoint.mdAndUp
    },

    isLarge: function () {
      return this.$vuetify.breakpoint.lg
    },

    showMini: function () {
      return this.open && this.isLarge
    },

    filteredLinks: function () {
      return this.links;//.filter(link => link.url !== 'clearance' || (window.location.href.includes('pg.nsuk.edu.ng') || window.location.href.includes('localhost') || window.location.href.includes('test.nsuk.edu.ng')))
    }
  },

  watch: {
    open: function (newVal) {
      this.iconSize = newVal ? 14 : 18;
      this.drawer = newVal
    },

    drawer: function (newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    },

    logoutUser: function (newVal) {
      if (newVal)
        this.logUserOut()
    }
  },
  created() {
    this.fetchGlobal()
  }
}
</script>

<style lang="scss" scoped>
@import '@/resources/styles/components/_navigation-drawer.scss';
</style>
